export function nullifyEmptyString(obj: { [key: string]: any }) {
  return Object.keys(obj).reduce((acc, key) => ({
    ...acc,
    [key]: obj[key] === '' ? null : obj[key]
  }), {})
}
